import { TokenAuthContext, useViewerEntity } from '@rahtab/auth/lib/token-based-auth';
import { createStackNavigator } from '@rahtab/stack-navigator';
import { NavigationContainer } from '@react-navigation/native';
import React, { lazy, useContext } from 'react';
import { Platform } from 'react-native';
import * as Screens from 'screens';
import StoreInventory from 'screens/Inventory/StoreInventory';

const Home = Platform.OS === 'web' ? lazy(() => import('./screens/Home')) : require('./screens/Home').default;
const Profile = Platform.OS === 'web' ? lazy(() => import('./screens/Profile')) : require('./screens/Profile').default;
const Billing =
  Platform.OS === 'web' ? lazy(() => import('./screens/Bill/Billing')) : require('./screens/Bill/Billing').default;
const InvoiceList =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/Bill/InvoiceList'))
    : require('./screens/Bill/InvoiceList').default;
const PayInfo =
  Platform.OS === 'web' ? lazy(() => import('./screens/Bill/PayInfo')) : require('./screens/Bill/PayInfo').default;
const QRScanner =
  Platform.OS === 'web' ? lazy(() => import('./screens/QRScanner')) : require('./screens/QRScanner').default;
const SaleHistory =
  Platform.OS === 'web' ? lazy(() => import('./screens/SaleHistory')) : require('./screens/SaleHistory').default;
const EditInfo =
  Platform.OS === 'web' ? lazy(() => import('./screens/EditInfo')) : require('./screens/EditInfo').default;
const Products =
  Platform.OS === 'web' ? lazy(() => import('./screens/Products')) : require('./screens/Products').default;
const CategoryMerchandises =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/CategoryMerchandises'))
    : require('./screens/CategoryMerchandises').default;
const MerchandiseInventory =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/Inventory/MerchandiseInventory'))
    : require('./screens/Inventory/MerchandiseInventory').default;
const OrderCategories =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/CategoryOrdering/OrderCategories'))
    : require('./screens/CategoryOrdering/OrderCategories').default;
const Listings =
  Platform.OS === 'web' ? lazy(() => import('./screens/Listings')) : require('./screens/Listings').default;
const ReceivedLoad =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/Inventory/ReceivedLoad'))
    : require('./screens/Inventory/ReceivedLoad').default;
const Merchandise =
  Platform.OS === 'web' ? lazy(() => import('./screens/Merchandise')) : require('./screens/Merchandise').default;
const ViewMessage =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/Support/ViewMessage'))
    : require('./screens/Support/ViewMessage').default;
const NewMessage =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/Support/NewMessage'))
    : require('./screens/Support/NewMessage').default;
const RegisterCustomers =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/RegisterCustomers'))
    : require('./screens/RegisterCustomers').default;
const OrdersHistory =
  Platform.OS === 'web' ? lazy(() => import('./screens/OrdersHistory')) : require('./screens/OrdersHistory').default;
const SubmitOrders =
  Platform.OS === 'web' ? lazy(() => import('./screens/SubmitOrders')) : require('./screens/SubmitOrders').default;
const LoadsList =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/Inventory/LoadsList'))
    : require('./screens/Inventory/LoadsList').default;
const TermsOfService =
  Platform.OS === 'web' ? lazy(() => import('./screens/TermsOfService')) : require('./screens/TermsOfService').default;
const AnounceLoadDelivery =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/AnounceLoadDelivery'))
    : require('./screens/AnounceLoadDelivery').default;
const FixLoadAmount =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/Inventory/FixLoadAmount'))
    : require('./screens/Inventory/FixLoadAmount').default;
const SubmitNewFix =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/Inventory/SubmitNewFix'))
    : require('./screens/Inventory/SubmitNewFix').default;
const StockList =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/Inventory/StockList'))
    : require('./screens/Inventory/StockList').default;
const EditLocationInfo =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/EditInfo/EditLocationInfo'))
    : require('./screens/EditInfo/EditLocationInfo').default;
const NewStock =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/Inventory/NewStock'))
    : require('./screens/Inventory/NewStock').default;
const StopStock =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/Inventory/StopStock'))
    : require('./screens/Inventory/StopStock').default;
const SelectEntityTypeCode =
  Platform.OS === 'web'
    ? lazy(() => import('./screens/SelectEntityTypeCode'))
    : require('./screens/SelectEntityTypeCode').default;

const Stack = createStackNavigator<RootStackType>();

const Router = () => {
  const { isSignout, aggreementIsSigned } = useContext(TokenAuthContext);
  const { viewerSelectedEntity } = useViewerEntity();

  return (
    <NavigationContainer>
      <Stack.Navigator
        authorizationOptions={{
          isSignout,
        }}
        screenOptions={{
          headerShown: false,
        }}>
        <Stack.Screen name="Landing" options={{ access: 'protected' }} component={Screens.Landing} />
        {!viewerSelectedEntity && (
          <Stack.Screen name="SelectEntityTypeCode" options={{ access: 'private' }} component={SelectEntityTypeCode} />
        )}
        {!aggreementIsSigned && (
          <Stack.Screen name="TermsOfService" options={{ access: 'private' }} component={TermsOfService} />
        )}
        <Stack.Screen name="Home" options={{ access: 'private' }} component={Home} />
        <Stack.Screen name="NTSW" options={{ access: 'private' }} component={Screens.NTSW} />
        <Stack.Screen name="Profile" options={{ access: 'private' }} component={Profile} />
        <Stack.Screen name="Billing" options={{ access: 'private' }} component={Billing} />
        <Stack.Screen name="InvoiceList" options={{ access: 'private' }} component={InvoiceList} />
        <Stack.Screen name="PayInfo" options={{ access: 'private' }} component={PayInfo} />
        <Stack.Screen name="QRScanner" options={{ access: 'private' }} component={QRScanner} />
        <Stack.Screen name="RegisterCustomers" options={{ access: 'private' }} component={RegisterCustomers} />
        <Stack.Screen name="SaleHistory" options={{ access: 'private' }} component={SaleHistory} />
        <Stack.Screen name="EditInfo" options={{ access: 'private' }} component={EditInfo} />
        <Stack.Screen name="EditLocationInfo" options={{ access: 'private' }} component={EditLocationInfo} />
        <Stack.Screen name="CompleteLocationInfo" options={{ access: 'private' }} component={EditLocationInfo} />
        <Stack.Screen name="CompleteInfo" options={{ access: 'private' }} component={EditInfo} />
        <Stack.Screen name="Products" options={{ access: 'private' }} component={Products} />
        <Stack.Screen name="OrderCategories" options={{ access: 'private' }} component={OrderCategories} />
        <Stack.Screen name="Listings" options={{ access: 'private' }} component={Listings} />
        <Stack.Screen name="CategoryMerchandises" options={{ access: 'private' }} component={CategoryMerchandises} />
        <Stack.Screen name="Merchandise" options={{ access: 'private' }} component={Merchandise} />
        <Stack.Screen name="MerchandiseInventory" options={{ access: 'private' }} component={MerchandiseInventory} />
        <Stack.Screen name="ReceivedLoad" options={{ access: 'private' }} component={ReceivedLoad} />
        <Stack.Screen name="Support" options={{ access: 'private' }} component={Screens.Support} />
        <Stack.Screen name="ViewMessage" options={{ access: 'private' }} component={ViewMessage} />
        <Stack.Screen name="NewMessage" options={{ access: 'private' }} component={NewMessage} />
        <Stack.Screen name="OrdersHistory" options={{ access: 'private' }} component={OrdersHistory} />
        <Stack.Screen name="SubmitOrders" options={{ access: 'private' }} component={SubmitOrders} />
        <Stack.Screen name="LoadsList" options={{ access: 'private' }} component={LoadsList} />
        <Stack.Screen name="AnounceLoadDelivery" options={{ access: 'private' }} component={AnounceLoadDelivery} />
        <Stack.Screen name="FixLoadAmount" options={{ access: 'private' }} component={FixLoadAmount} />
        <Stack.Screen name="SubmitNewFix" options={{ access: 'private' }} component={SubmitNewFix} />
        <Stack.Screen name="StoreInventory" options={{ access: 'private' }} component={StoreInventory} />
        <Stack.Screen name="StockList" options={{ access: 'private' }} component={StockList} />
        <Stack.Screen name="NewStock" options={{ access: 'private' }} component={NewStock} />
        <Stack.Screen name="StopStock" options={{ access: 'private' }} component={StopStock} />
      </Stack.Navigator>
    </NavigationContainer>
  );
};

export default Router;

export type RootStackType = {
  SelectEntityTypeCode: undefined;
  NTSW: undefined;
  Landing: undefined;
  OutdatedApp: undefined;
  EnterPassword: {
    mobileNumber: string;
  };
  Home: {
    qrData?: string;
  };
  Profile: undefined;
  Billing: undefined;
  InvoiceList: {
    transactionCount: string;
  };
  PayInfo: {
    billCode: string;
  };
  EditInfo: undefined;
  EditLocationInfo: undefined;
  CompleteLocationInfo: undefined;
  CompleteInfo: undefined;
  Products: {
    sell?: boolean;
    customerName?: string;
  };
  Merchandise: {
    name?: string;
    distDate?: string;
    distType?: string;
    price?: string;
    image?: string;
    available?: string;
  };
  StoreInventory: undefined;
  MerchandiseInventory: {
    id: string;
  };
  Support: {
    refetch?: boolean;
  };
  ViewMessage: {
    id: string;
    type: 'Recieve' | 'Send';
  };
  NewMessage: undefined;
  SaleHistory: undefined;
  OrderCategories: undefined;
  CategoryMerchandises: {
    id: string;
  };

  Listings: {
    merchandiseId?: string;
  };
  ReceivedLoad: {
    merchandiseId: string;
    assignFinalCode: string;
  };
  TermsOfService: undefined;
  RegisterCustomers: undefined;
  QRScanner: undefined;
  OrdersHistory: {
    merchandiseId: string;
    merchandiseName: string;
    merchandiseImage: string;
  };
  SubmitOrders: {
    listingId: string;
  };
  LoadsList: {
    merchandiseId: string;
  };
  AnounceLoadDelivery: {
    merchandiseId: string;
    assignFinalCode: string;
  };
  FixLoadAmount: {
    assignFinalCode: string;
    refreshing?: boolean;
  };
  SubmitNewFix: {
    assignFinalCode: string;
  };
  StockList: {
    assignFinalCode: string;
    refreshing?: boolean;
  };
  NewStock: {
    assignFinalCode: string;
  };
  StopStock: {
    assignFinalCode: string;
    stockCode: string;
  };
};
